import React from 'react';
import { Icons } from '../Icons/Icons';
import './SearchInput.scss';

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Search here',
  value,
  onChange,
}) => {
  return (
    <div className="search-input-wrapper">
      <input type="search" placeholder={placeholder} value={value} onChange={onChange} />
      <span className="search-icon">{Icons.SearchInput}</span>
    </div>
  );
};
